import axios from 'axios'
import { useUserAuthStore } from '../stores/global/userAuth'

const createAxiosInstance = (p0?: {}) => {
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API,
    headers: {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
    },
    validateStatus: (status) => true,
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const updatedToken = localStorage.getItem('token');
      if (updatedToken) {
        config.headers.Authorization = `Bearer ${updatedToken}`;
      }
      return config;
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.status === 401) {
        useUserAuthStore.getState().forcedUserLogout()
      }
      return response
    },
    async (error) => {
      if (error.response?.status === 401) {
        useUserAuthStore.getState().forcedUserLogout()
      }
      return error;
    }
  );

  return axiosInstance;
}

export const axiosInstance = createAxiosInstance;
